<template>
  <main class="main community community_write" role="main">
    <div class="main_con">
      <div class="select_box border">
        <div
          class="col-2"
          @click="openCatetoryModal"
          :style="{ color: !selectedCategory ? '#bdbdbd' : '#212121' }"
        >
          {{ !selectedCategory ? '질문유형' : selectedCategory.label }}
          <i class="i_select"></i>
        </div>
        <div class="col-2" @click="gotoRegion">
          {{ area.areaFullName }}<i class="i_select"></i>
        </div>
      </div>
      <div class="ttl border">
        <input placeholder="제목을 입력하세요." v-model="form.title" />
      </div>
      <div class="textarea border high_34">
        <textarea placeholder="내용을 입력하세요." v-model="form.contents" />
      </div>
      <div class="img_box_wrap">
        <div
          class="img_box"
          v-for="(item, index) in form.images"
          :key="(item, index)"
        >
          <img alt="" :src="item.imagePath" />
          <button @click.stop="removeImage(item, index)">
            <i class="i_x_w"></i>
          </button>
        </div>
      </div>
      <div class="btm_btn">
        <div class="attach_btn border" @click="uploadImage">
          <i class="i_img_upload"></i>
          사진첨부
        </div>
        <ImageInput ref="imageInput" @change="changeImage" />
        <div class="btn_wrap">
          <button class="btn" @click="fnSave">질문하기</button>
        </div>
      </div>
    </div>
    <CategoryModal
      ref="CategoryModal"
      :value="selectedCategory"
      :show="isCategoryModal"
      @close="closeCategoryModal"
    />
    <transition name="fade">
      <div class="made_toast_layer_common" style="top:83%;" v-if="isViewToast">
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
    <DesignPopup :show="openDesignPopup" :data="popupParams" @close="confirm" />
  </main>
</template>

<script>
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapGetters as communityGetters,
  mapActions as communityMapActions,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import CategoryModal from '@/front/customer/views/community/modal/CategoryModal';
import ImageInput from '@common/components/ImageInput';

export default {
  name: 'community-knowhow-write',
  description: '커뮤니티 > 지식인 작성',
  components: {
    DesignPopup,
    CategoryModal,
    ImageInput,
  },
  data() {
    return {
      boardId: this.$route.query.boardId || '',
      form: {
        isAnonymous: 'N',
        category: '',
        areaName: '',
        areaFullName: '',
        title: '',
        contents: '',
        images: [],
        imageFile: [],
      },
      removeFiles: [], // 삭제 이미지
      isCategoryModal: false,
      selectedCategory: '',
      area: {
        areaName: '',
        areaFullName: '',
      },
      isViewToast: false,
      errorMessage: '',
      openDesignPopup: false,
      popupParams: {},
      mode: 'CREATE', // CREATE: 등록, UPDATE: 수정
      categories: [
        { label: '휴대폰', value: 'MOBILE' },
        { label: '인터넷', value: 'INTERNET' },
        { label: '알뜰폰', value: 'MVNO' },
        { label: '요금제', value: 'PLAN' },
        { label: '렌탈', value: 'RENTAL' },
        { label: '매장', value: 'STORE' },
      ],
    };
  },
  async created() {
    await this[userTypes.FETCH_ME]();

    if (this.user) {
      this.area.areaName = this.user.emdAreaNameShort;
      this.area.areaFullName = this.user.emdAreaName;
    }
    this.getStorageForm();

    if (this.boardId) {
      this.form.id = this.boardId;
      this[communityTypes.FETCH_KNOWHOW]({
        id: this.boardId,
        isRead: 'N',
      }).then(() => {
        this.mode = 'UPDATE';
        console.log('knowhow ::: {}', this.knowhow);
        this.area.areaName = this.knowhow.areaName;
        this.area.areaFullName = this.knowhow.areaFullName;
        this.form.category = this.knowhow.category;
        this.form.areaFullName = this.knowhow.areaFullName;
        this.form.title = this.knowhow.title;
        this.form.contents = this.knowhow.contents;
        this.form.images = this.knowhow.images;
        console.log('form ::: {}', this.form);

        const category = this.categories.filter(
          item => item.value === this.knowhow.category,
        );
        this.selectedCategory = category[0];
        this.$refs.CategoryModal.selectedValue = category[0];
      });
    }
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...communityGetters({ knowhow: communityTypes.FETCH_KNOWHOW }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...communityMapActions([
      communityTypes.FETCH_KNOWHOW,
      communityTypes.CREATE_KNOWHOW,
      communityTypes.UPDATE_KNOWHOW,
    ]),
    getStorageForm() {
      const form = localStorage.getItem('knowhow-form');
      console.log('formformformformformformform');
      console.log(form);
      if (form) {
        this.form = { ...JSON.parse(form) };

        const category = this.categories.filter(
          item => item.value === this.form.category,
        );
        this.selectedCategory = category[0];
        this.$refs.CategoryModal.selectedValue = category[0];

        localStorage.removeItem('knowhow-form');
      }

      const area = localStorage.getItem('knowhow-area');
      if (area) {
        this.area = JSON.parse(area);
        localStorage.removeItem('knowhow-area');
      }
    },
    gotoRegion() {
      localStorage.setItem('knowhow-form', JSON.stringify(this.form));
      let codeType = 'e';
      let areaId = this.user.emdAreaId;
      if (this.user.admName) {
        const admArea = JSON.parse(this.user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          areaName: this.user.emdAreaName.substring(
            this.user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: this.user.emdAreaName,
          areaId,
          codeType,
          from: 'Knowhow',
        },
      });
    },
    fnSave() {
      if (!this.form.category) {
        this.errorMessage = '질문유형을 선택해주세요';
        this.toastView();
        return;
      }
      if (!this.form.title) {
        this.errorMessage = '제목을 입력해주세요';
        this.toastView();
        return;
      }
      if (!this.form.contents) {
        this.errorMessage = '내용을 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.title.length < 4) {
        this.errorMessage = '제목을 4자 이상 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.contents.length < 4) {
        this.errorMessage = '내용을 4자 이상 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.images.length > 10) {
        this.errorMessage = '사진등록은 10장까지 가능합니다';
        this.toastView();
        return;
      }
      this.popupParams = {
        type: 'confirm',
        msg: `질문을 ${this.mode === 'CREATE' ? '등록' : '수정'} 하시겠습니까?`,
      };
      this.openDesignPopup = true;
    },
    confirm(isSave) {
      if (isSave) {
        const payload = this.convertToFormData();
        if (this.mode === 'CREATE') {
          this[communityTypes.CREATE_KNOWHOW](payload).then(() => {
            this.popupParams = { type: 'alert', msg: '질문이 등록되었습니다' };
          });
        } else {
          this[communityTypes.UPDATE_KNOWHOW](payload).then(() => {
            this.popupParams = { type: 'alert', msg: '질문이 수정되었습니다' };
          });
        }
      } else {
        this.openDesignPopup = false;
        if (this.popupParams.type === 'alert') {
          this.$router.replace({ name: 'Knowhow.List' });
        }
      }
    },
    convertToFormData() {
      const payload = new FormData();

      this.form = Object.assign(this.form, this.area);

      for (const [key, value] of Object.entries(this.form)) {
        if (key !== 'images') {
          payload.append(key, value);
        }
      }

      // 새로 등록된 파일
      if (this.form.images.length > 0) {
        for (const i in this.form.images) {
          if (this.form.images[i].file) {
            payload.append('attachFile', this.form.images[i].file);
          }
        }
      }

      // 삭제된 파일
      if (this.removeFiles.length > 0) {
        for (const i in this.removeFiles) {
          if (this.removeFiles[i].id) {
            payload.append('removeAttachmentFile', this.removeFiles[i].id);
          }
        }
      }
      return payload;
    },
    uploadImage() {
      if (this.form.images.length > 10) {
        this.errorMessage = '사진등록은 10장까지 가능합니다';
        this.toastView();
        return;
      }
      this.$refs.imageInput.click();
    },
    changeImage(file) {
      //this.form.images.push(file);
      console.log('filefilefilefilefile');
      console.log(file);

      if (this.form.images.length > 0) {
        // console.log('this.form.images');
        // console.log(this.form.images);
        this.form.imageFile = this.form.images;
        // console.log('this.form.imageFile');
        // console.log(this.form.imageFile);
        this.form.images = file;
        // console.log('this.form.images');
        // console.log(this.form.images);
        this.form.images.push(...this.form.imageFile);
      } else {
        this.form.images = file;
      }
    },
    removeImage(item, idx) {
      this.form.images.splice(idx, 1);
      this.removeFiles.push(item);
    },
    openCatetoryModal() {
      this.isCategoryModal = true;
    },
    closeCategoryModal(val) {
      if (val) {
        this.selectedCategory = val;
        this.form.category = val.value;
      }
      this.isCategoryModal = false;
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>

<style></style>
